if (process.env.NODE_ENV === 'mock') {
  console.log('creating mock service');
  require('../miragejs/server').makeServer();
}
